import c0 from './ages_controller';
import c1 from './copy_to_clipboard_controller';
import c2 from './dependent_controller';
import c3 from './details_controller';
import c4 from './first_error_controller';
import c5 from './form_controller';
import c6 from './image_upload_bypass_controller';
import c7 from './image_upload_controller';
import c8 from './menu_controller';
import c9 from './modal_controller';
import c10 from './nested_controller';
import c11 from './number_field_controller';
import c12 from './other_controller';
import c13 from './password_peek_controller';
import c14 from './queue_controller';
import c15 from './reveal_controller';
import c16 from './search_controller';
import c17 from './select_all_controller';
import c18 from './sortable_controller';
import c19 from './subsection_controller';
import c20 from './toggler_controller';
import c21 from './turnstile_controller';
import c22 from './welfare_controller';
export const definitions = [
	{identifier: 'ages', controllerConstructor: c0},
	{identifier: 'copy-to-clipboard', controllerConstructor: c1},
	{identifier: 'dependent', controllerConstructor: c2},
	{identifier: 'details', controllerConstructor: c3},
	{identifier: 'first-error', controllerConstructor: c4},
	{identifier: 'form', controllerConstructor: c5},
	{identifier: 'image-upload-bypass', controllerConstructor: c6},
	{identifier: 'image-upload', controllerConstructor: c7},
	{identifier: 'menu', controllerConstructor: c8},
	{identifier: 'modal', controllerConstructor: c9},
	{identifier: 'nested', controllerConstructor: c10},
	{identifier: 'number-field', controllerConstructor: c11},
	{identifier: 'other', controllerConstructor: c12},
	{identifier: 'password-peek', controllerConstructor: c13},
	{identifier: 'queue', controllerConstructor: c14},
	{identifier: 'reveal', controllerConstructor: c15},
	{identifier: 'search', controllerConstructor: c16},
	{identifier: 'select-all', controllerConstructor: c17},
	{identifier: 'sortable', controllerConstructor: c18},
	{identifier: 'subsection', controllerConstructor: c19},
	{identifier: 'toggler', controllerConstructor: c20},
	{identifier: 'turnstile', controllerConstructor: c21},
	{identifier: 'welfare', controllerConstructor: c22},
];
